import { logWarn } from './logger';

import type { Maybe } from '@web-platform/shared-universal-types-utils/src/utils';

const isNonNullish = <T>(val: T): val is NonNullable<T> => val != null;

export const nonNullishOrThrow = <T>(value: Maybe<T>, name?: string): T => {
  if (isNonNullish(value)) {
    return value;
  }

  throw new Error(`Nullish property encountered${name ? `: ${name}` : ''}`);
};

export const nonNullishOrFallback = <T>(value: Maybe<T>, fallback: T, name?: string): T => {
  if (isNonNullish(value)) {
    return value;
  }

  logWarn({
    component: 'assertNonNullish',
    source: String(name),
    message: `Nullish property encountered. Falling back to default value`,
  });

  return fallback;
};
